import {
    DepositSurveyAnswersContainerStyled,
    DepositSurveyAnswerStyled,
    DepositSurveyButtonsContainerStyled,
    DepositSurveyStyled
} from "./styled/DepsotSurveyStyled";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DEPOSIT_SURVEY_ANSWER_OTHERS, DEPOSIT_SURVEY_ANSWERS } from "./depositSurveyConstants";
import _ from "lodash";
import { Button, Form } from "react-bootstrap";
import classNames from "classnames";
import { useZendeskContext } from "../Zendesk/zendeskContext";
import { useDispatch } from "react-redux";
import { sendDepositSurveyResultStartAction } from "../Account/accountActions";

function DepositSurvey(props) {
    const {handleCloseSurvey} = props;
    const {isWebWidgetInited, openWebWidget} = useZendeskContext();
    const {getLangPath} = useLangContext();
    const [selectedAnswer, setSelectedAnswer] = useState('');
    const isDepositSurveyAnswerSentRef = useRef(false);

    const dispatch = useDispatch();

    const answersList = useMemo(() => {
        const shuffledAnswers = _.shuffle(DEPOSIT_SURVEY_ANSWERS);
        return [...shuffledAnswers, DEPOSIT_SURVEY_ANSWER_OTHERS]
    }, []);

    // Уведомляем сервер что пользователь закрыл опрос
    useEffect(() => {
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            if (!isDepositSurveyAnswerSentRef.current) {
                dispatch(sendDepositSurveyResultStartAction({
                    answers_list: answersList,
                    survey_closed: true,
                }));
            }
        }
    }, [answersList, dispatch]);

    const handleSelectAnswer = useCallback((e) => {
        const answer = e.currentTarget.dataset.value;
        setSelectedAnswer(answer);
    }, []);

    const handleSendAnswerButtonClick = useCallback(() => {
        dispatch(sendDepositSurveyResultStartAction({
            answer: selectedAnswer,
            answers_list: answersList,
            survey_closed: false,
        }));
        isDepositSurveyAnswerSentRef.current = true;
        handleCloseSurvey();
    }, [answersList, dispatch, handleCloseSurvey, selectedAnswer]);

    return <DepositSurveyStyled>
        <h3>{getLangPath('deposit.survey.title')}</h3>
        <p>{getLangPath('deposit.survey.description')}</p>
        <DepositSurveyAnswersContainerStyled>
            {
                answersList.map(answer => <DepositSurveyAnswerStyled
                    className={classNames({selected: selectedAnswer === answer})}
                    data-value={answer}
                    key={answer}
                    onClick={handleSelectAnswer}
                >
                    <Form.Check
                        checked={selectedAnswer === answer}
                        readOnly
                        type={'radio'}
                        name={'deposit_survey_answer'}
                        value={answer}
                        id={answer}
                    />
                    <span>{getLangPath(`deposit.survey.answers.${answer}`)}</span>
                </DepositSurveyAnswerStyled>)
            }
        </DepositSurveyAnswersContainerStyled>
        <DepositSurveyButtonsContainerStyled>
            <Button variant={'primary'} size={'lg'} disabled={!selectedAnswer} onClick={handleSendAnswerButtonClick}>
                {getLangPath('deposit.survey.send_answer')}
            </Button>
            <Button variant={'outline'} size={'lg'} disabled={!isWebWidgetInited} onClick={openWebWidget}>
                {getLangPath('deposit.survey.need_help')}
            </Button>
        </DepositSurveyButtonsContainerStyled>
    </DepositSurveyStyled>
}

export default DepositSurvey;
